import {ClickerGCSEngine} from '../ui/pages/ClickerGamePage/clicker-game/ClickerGame.types';
import {Point} from 'pixi.js';
import {DI_TOKENS} from 'src/di/di.tokens';

import {injected} from 'brandi';

import {BaseComponent, Transform2dComponent} from '@specials/gcs-engine';

import {PixiViewComponent} from './PixiViewComponent';

export class PixiViewRendererComponent extends BaseComponent {
  private transformComponent: Transform2dComponent;
  private viewComponent: PixiViewComponent;

  constructor(private readonly engine: ClickerGCSEngine) {
    super();
  }

  public onAddToWorld(): void {
    this.viewComponent = this.gameObject.getComponentByTag<PixiViewComponent>('ViewComponent')!;
    this.transformComponent = this.gameObject.getComponent<Transform2dComponent>(Transform2dComponent)!;

    const {x, y} = this.transformComponent.position;
    this.viewComponent.view.position = new Point(x, y);
    this.transformComponent.bindPosition = this.viewComponent.view.position;
    this.transformComponent.bindScale = this.viewComponent.view.scale;
    this.transformComponent.bindRotation = this.viewComponent.view.rotation;

    this.engine.renderer.container.addChild(this.viewComponent.view);
  }

  public destroy(): void {
    this.engine.renderer.container.removeChild(this.viewComponent.view);
  }
}

injected(PixiViewRendererComponent, DI_TOKENS.gcsEngine);
